<template>
  <skeleton-el :style="{ height, width: computedWidth, paddingTop }" :class="{ 'skeleton-box': !imgLoaded }">
    <img v-if="image" :src="image" :alt="alt" @load="onImgLoad" @error="$changeDefaultImage" />
  </skeleton-el>
</template>

<script>
export default {
  name: `SkeletonBox`,
  data() {
    return { imgLoaded: false };
  },
  props: {
    maxWidth: {
      default: 100,
      type: Number,
    },
    minWidth: {
      default: 80,
      type: Number,
    },
    height: {
      default: `1em`,
      type: String,
    },
    width: {
      default: null,
      type: String,
    },
    paddingTop: {
      type: String,
    },
    image: {
      type: String,
    },
    alt: {
      type: String,
    },
  },
  computed: {
    computedWidth() {
      return this.width || `${Math.floor(0.9 * (this.maxWidth - this.minWidth) + this.minWidth)}%`;
    },
  },
  methods: {
    onImgLoad() {
      this.imgLoaded = true;
    },
  },
};
</script>

<style lang="scss">
.skeleton-box {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  background-color: #e3e3e3;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: shimmer 4.5s infinite;
    content: '';
  }
  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
